import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-enable-authenticator-app-recovery-code',
  templateUrl: './enable-authenticator-app-recovery-code.component.html'
})
export class EnableAuthenticatorAppRecoveryCodeComponent implements OnInit {
  @Input('recoveryCodes') recoveryCodes!: string;
  @Output('copy') copy = new EventEmitter();
  @Output('close') closeDialog = new EventEmitter();


  constructor() {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  async copyToClipboard(){
    this.copy.emit();
  }

  async close(){
    this.closeDialog.emit();
  }

}
